// Import the main SCSS file to be processed by Webpack and included in the final CSS output
import '../scss/main.scss';

// Import the typewriterEffect and initTypewriterObserver functions from the _typewriter.js module
import { initTypewriterObserver } from './_animation-typewriter';

// Import the entranceEffect function from the _animation-entrance';
import { entranceEffect } from './_animation-entrance';

// Import the initAnimatedCursor function from the _animated-cursor.js module
import { initAnimatedCursor } from './_animated-cursor';

// Import the hideSingleSlideControls function from the _slider-controls.js module
import { hideSingleSlideControls } from './_slider-controls';

// Import the initSectionHeadings function from the section-headings.js module
import { initSectionHeadings } from './_section-headings';

// Import the initNavMobile function from the _nav-mobile.js module
import { initNavMobile } from './_nav-mobile';

// Import the CookieYes functionality from the _cookieyes.js module
import { initCookieYes } from './_cookieyes';

// Import Google Maps initialization
import { initGoogleMaps } from './_google-maps';

// This makes the Google Maps initialization available as a global function
// so it can be called by the Google Maps API when it loads asynchronously
window.initViralTribeMaps = function () {
    if (typeof initGoogleMaps === 'function') {
        initGoogleMaps();
    }
};

// This runs when the DOM is ready
document.addEventListener('DOMContentLoaded', function () {
    // Check for the main element and add ID if it doesn't exist
    var mainElement = document.querySelector('main');
    if (mainElement && !mainElement.id) {
        mainElement.id = 'content';
    }

    // Initialize the CookieYes functionality
    initCookieYes();

    // Hide controls for sliders which only have one slide
    hideSingleSlideControls();

    // Initialize the entrance animation effect
    entranceEffect();

    // Initialize the typewriter observer
    initTypewriterObserver();

    // Initialize the animated cursor
    initAnimatedCursor();

    // Initialize the section headings
    initSectionHeadings();

    // Initialize the nav mobile function
    initNavMobile();
});
